import { Pipe, PipeTransform } from '@angular/core';

const TRANSLATIONS: Record<string, string> = {
    de: 'UTIL_COMMON.LANGUAGE.GERMAN',
    en: 'UTIL_COMMON.LANGUAGE.ENGLISH'
};

/**
 * Returns the translation key for the given device type.
 */
@Pipe({
    name: 'sonaLanguage',
    standalone: true
})
export class SonaLanguagePipe implements PipeTransform {
    transform(language: string): string {
        return TRANSLATIONS[language];
    }
}
